import httpClient from 'shared/utils/http-client'
import {
  AvailabilityCreateInterface,
  AvailabilityUpdateInterface,
} from '../types/availability-interface'

export const AVAILABILITY_API = '/api/dashboard/booking-calendar/user-availability'

export const updateGlobalAvailability = (data: AvailabilityUpdateInterface) =>
  httpClient.put<AvailabilityCreateInterface>(AVAILABILITY_API, data)

export const createGlobalAvailability = (data: AvailabilityCreateInterface) =>
  httpClient.post<AvailabilityCreateInterface, AvailabilityCreateInterface>(AVAILABILITY_API, data)
